import { HTMLAttributes } from 'react';
import { Wrapper } from '../Wrapper';
import styles from './styles.module.scss';

export type SubHeaderProps = HTMLAttributes<HTMLDivElement> & {
  variant?: 'default' | 'green';
};

export const SubHeader = ({ children, variant = 'default' }: SubHeaderProps) => (
  <div className={`${styles.subHeader} ${styles[variant]}`}>
    <Wrapper>{children}</Wrapper>
  </div>
);
